import { OrganizationTin } from '@models/organizationTin.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const TaxIdentificationNumberDetailsActions = createActionGroup({
  source: 'TaxIdentificationNumberDetails',
  events: {
    'Component TIN Details Loaded': emptyProps(),
    'Open Add Tin Pressed': emptyProps(),
    'Open Edit Tin Pressed': props<{tin: OrganizationTin}>(),
    'Open Delete Tin Pressed': props<{name: string, id: string}>(),
    'Items Per Page Changed': props<{ items: number }>(),
    'Page Number Changed': props<{ page: number }>(),

    'Get TIN Details Success': props<{ details: OrganizationTin[], totalItems: number}>(),
    'Get TIN Details Failure': props<{ error: string }>(),

    'Add TIN Save': props<{ data: OrganizationTin }>(),
    'Add TIN Success': props<{ data: OrganizationTin}>(),
    'Add TIN Failure': props<{ error: string }>(),

    'Edit TIN': props<{ data: OrganizationTin }>(), 
    'Edit TIN Success': props<{data: OrganizationTin}>(),
    'Edit TIN Failure': props<{ error: string }>(),

    'Delete TIN': props<{ id: any }>(),
    'Delete TIN Success': props<{id: any}>(),
    'Delete TIN Failure': props<{ error: string }>(),
  }
});
